__turbopack_context__.v({
  "actions": "Card-module__glvFVa__actions",
  "body": "Card-module__glvFVa__body",
  "boxed": "Card-module__glvFVa__boxed",
  "card": "Card-module__glvFVa__card",
  "children": "Card-module__glvFVa__children",
  "contents": "Card-module__glvFVa__contents",
  "contentsBox": "Card-module__glvFVa__contentsBox",
  "description": "Card-module__glvFVa__description",
  "descriptionClamped": "Card-module__glvFVa__descriptionClamped",
  "header": "Card-module__glvFVa__header",
  "headerImage": "Card-module__glvFVa__headerImage",
  "heading": "Card-module__glvFVa__heading",
  "image": "Card-module__glvFVa__image",
  "imageBorder": "Card-module__glvFVa__imageBorder",
  "imageCard": "Card-module__glvFVa__imageCard",
  "imageFlip": "Card-module__glvFVa__imageFlip",
  "metadata": "Card-module__glvFVa__metadata",
  "responsive": "Card-module__glvFVa__responsive",
  "tags": "Card-module__glvFVa__tags",
  "withImage": "Card-module__glvFVa__withImage",
});
